import { API } from "../config";
import { SearchTypes } from "../types";

export const getAllSearchHistory = async () => {
  const response = await API.get("/user/search");
  return response?.data;
};

export const getAllTotalDetails = async () => {
  const response = await API.get("user/search/total");
  return response?.data?.data;
};

export const getTotalAmountSpent = async () => {
  const response = await API.get("/user/user/amount");
  return response?.data?.data;
};
export const getLocalGovernment = async (page: number) => {
  const response = await API.get(`/lgas?page=${page}`);
  return response?.data;
};
export const getStates = async () => {
  const response = await API.get("/states");
  return response?.data?.data;
};
export const getJudicialDivisions = async (page: number) => {
  const response = await API.get(`/judicial-divisions?page=${page}`);
  return response?.data?.data;
};

export const getJudicialDivisionById = async (id: number | undefined) => {
  const response = await API.get(`/admin/judicial-divisions/${id}`);
  return response?.data?.data;
};

export const initiateSearch = async (data: SearchTypes) => {
  const response = await API.post("/user/search/initiate", data);
  return response?.data;
};
export const verifyPayment = async (data: { reference: string | null }) => {
  const response = await API.post("/payments/verify", data);
  return response?.data;
};
export const showSearch = async (data: { reference: string }) => {
  const response = await API.post("/user/search/show", data);
  return response?.data;
};
export const finalizeSearch = async (data: { reference: string }) => {
  const response = await API.post("/user/search/finalize", data);
  return response?.data;
};
export const guestSearch = async (data: {
  name: string;
  email: string;
  type: string;
  payment_method?: string;
  lga_id: number | string | undefined;
  state_id: number | string | undefined;
}) => {
  const response = await API.post("/searchs", data);
  return response?.data;
};

export const getPaymentGateways = async () => {
  const response = await API.get("/payment-gateways");
  return response?.data?.data;
};

export const updateApplicationPayment = async (
  id: number | string,
  payload: {
    callback_url: string;
    payment_gateway_id: number | string;
  },
) => {
  const response = await API.post(`/payments/${id}/update`, payload);
  return response.data;
};

// export const getGeneralSettings = async () => {
//   const response = await API.get("/settings/show");
//   return response?.data?.data;
// };
